/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: gHGPazbS0-f7
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicSeparatorVertical.module.css"; // plasmic-import: gHGPazbS0-f7/css

createPlasmicElementProxy;

export const PlasmicSeparatorVertical__VariantProps = new Array(
  "color",
  "width"
);

export const PlasmicSeparatorVertical__ArgProps = new Array();

const $$ = {};

function PlasmicSeparatorVertical__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      },
      {
        path: "width",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.width
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcolor_localSeparator]: hasVariant(
            $state,
            "color",
            "localSeparator"
          ),
          [sty.rootcolor_uiSeparator]: hasVariant(
            $state,
            "color",
            "uiSeparator"
          ),
          [sty.rootwidth_m]: hasVariant($state, "width", "m"),
          [sty.rootwidth_s]: hasVariant($state, "width", "s")
        }
      )}
    />
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSeparatorVertical__ArgProps,
          internalVariantPropNames: PlasmicSeparatorVertical__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSeparatorVertical__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSeparatorVertical";
  } else {
    func.displayName = `PlasmicSeparatorVertical.${nodeName}`;
  }
  return func;
}

export const PlasmicSeparatorVertical = Object.assign(
  // Top-level PlasmicSeparatorVertical renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicSeparatorVertical
    internalVariantProps: PlasmicSeparatorVertical__VariantProps,
    internalArgProps: PlasmicSeparatorVertical__ArgProps
  }
);

export default PlasmicSeparatorVertical;
/* prettier-ignore-end */
